import { Button } from '@material-ui/core'
import React from 'react'
import { useAppDialog } from '../use-app-dialog'
import { useMsal } from '@azure/msal-react'
import { msalRequest } from '../../env-config'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUser } from '../../store/auth/selectors'
import { useTranslation } from 'react-i18next'
import { AppDialogVariants } from '../../store/app-dialog/types'
import { useOverlayPreloader } from '../use-overlay-preloader'

export const useAuthRedirect = () => {
  const { setAppDialog } = useAppDialog()
  const { instance } = useMsal()
  const navigate = useNavigate()
  const user = useSelector(selectUser)
  const { t } = useTranslation()
  const { setIsShowOverlayPreloader } = useOverlayPreloader()

  /**
   * @description This function is used to show the login dialog
   * @param closeAppDialogHandler
   * @param redirectUri
   */
  const loginConfirm = (closeAppDialogHandler: (uri: string) => void, redirectUri = '/') => {
    setAppDialog({
      isShow: true,
      title: t('header.nonAuthComponent.loginDialog.title'),
      message: t('header.nonAuthComponent.loginDialog.message'),
      variant: AppDialogVariants.info,
      actions: (
        <>
          <Button onClick={() => setAppDialog({ isShow: false })}>
            {t('buttons.cancel')}
          </Button>
          <Button onClick={() => closeAppDialogHandler(redirectUri)}>
            {t('buttons.ok')}
          </Button>
        </>
      ),
    })
  }

  /**
   * Starts MSAL login. `postLoginPath` is where the app navigates after success (via `state`).
   * OAuth `redirect_uri` stays `/` so it matches the URI registered in Azure Entra.
   */
  const handleLoginRedirect = (postLoginPath = '/') => {
    setIsShowOverlayPreloader(true)
    const path = postLoginPath.startsWith('/') ? postLoginPath : `/${postLoginPath}`
    instance
      .loginRedirect({
        ...msalRequest,
        redirectUri: '/',
        state: path,
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          console.log(error)
        }
      })
  }

  /**
   * @description This function is used to handle the auth redirect
   * @param e
   * @param redirectUri
   * @param navigateTo
   */
  const authRedirectHandle = (e: React.MouseEvent, redirectUri = '/', navigateTo= '/') => {
    e.preventDefault()
    if (user.userId) {
      navigate(navigateTo)
    } else {
      loginConfirm(handleLoginRedirect, redirectUri)
    }
  }

  return {
    authRedirectHandle,
    handleLoginRedirect
  }
}
